import React from 'react';
import Link, { withPrefix } from 'gatsby-link';
import { observer, inject } from 'mobx-react';
import {Container, Row, Column} from '../../global/grid/grid';

import { CSOverlayWrapper } from './styled-components';

const CSOverlay = inject("store")(observer(({data, transitionState, store, location}) => {
    const gaCitySelected = (city, state) => {
        window.dataLayer.push({
            'event': 'herocity-dropdown:select',
            'city': city + "," + state
        });
    }
    return (
        <CSOverlayWrapper>
            <div className={`overlay ${transitionState}`}>
                <Container>
                    <Row>
                        {
                            data.filter(page => page.slug !== location.pathname.split('/')[1])
                                .map((page, index) => {
                                return (
                                <Column key={index} cw={12}>
                                    <div className="cityAndState">
                                        <div className={`city ${page.slug === store.csSlug ? 'current': ''}`}>
                                            <Link to={withPrefix(page.slug)} onClick={ () => { gaCitySelected(page.hero.city, page.hero.state) } }>
                                                <div style={{display: 'inline-block'}}>{page.hero.city}</div>
                                            </Link>
                                        </div>
                                        <div className="state">
                                            <Link to={withPrefix(page.slug)} onClick={ () => { gaCitySelected(page.hero.city, page.hero.state) } }>
                                                <div style={{display: 'inline-block'}}>{page.hero.state}</div>
                                            </Link>
                                        </div>
                                    </div>
                                </Column>
                                )
                            })
                        }
                    </Row>
                </Container>
            </div>
        </CSOverlayWrapper>
    )
}));

export default CSOverlay;



// WEBPACK FOOTER //
// ./src/components/modules/CSOverlay/CSOverlay.js